"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleStateResource = handleStateResource;
const getState_1 = require("../../../app/dist/getState");
const dist_1 = require("../../../fs/dist");
const dist_2 = require("../../../fs/dist");
const dist_3 = require("../../../core/dist");
const fs = __importStar(require("fs-extra"));
const stateCache_1 = require("../stateCache");
const VALID_STATUSES = ['CANCELLED', 'IMPLEMENTING', 'ACTIVE', 'DONE', 'BLOCKED'];
async function handleStateResource(root, uri) {
    const startedAt = Date.now();
    const url = new URL(uri.replace('loom://', 'loom://host/'));
    const weaveSlug = url.searchParams.get('weaveSlug') ?? undefined;
    const statusParam = url.searchParams.get('status') ?? undefined;
    const includeParam = url.searchParams.get('include') ?? undefined;
    const shapeParam = url.searchParams.get('shape') ?? undefined;
    const status = statusParam
        ? statusParam
            .split(',')
            .map(s => s.trim().toUpperCase())
            .filter((s) => VALID_STATUSES.includes(s))
        : undefined;
    const weaveFilter = (weaveSlug || (status && status.length > 0))
        ? {
            ...(weaveSlug ? { idPattern: weaveSlug } : {}),
            ...(status && status.length > 0 ? { status } : {}),
        }
        : undefined;
    const includeContent = includeParam === 'content';
    const isSummary = shapeParam === 'summary';
    // `shape` only changes serialization, never what state we load — so it does
    // not affect caching. An unfiltered read (with or without ?shape=summary) is
    // the tree's hot path and reuses the cached full state.
    const isUnfiltered = !weaveFilter && !includeContent;
    (0, stateCache_1.initStateCache)(root);
    // Resolve the full state once: cached for unfiltered reads (the tree's hot
    // path), recomputed for filtered ones (session-start, status queries).
    let state = isUnfiltered ? (0, stateCache_1.getCachedState)() : null;
    const cacheHit = state != null;
    if (!state) {
        const registry = new dist_2.ConfigRegistry();
        state = await (0, getState_1.getState)({ getActiveLoomRoot: dist_1.getActiveLoomRoot, loadWeave: dist_1.loadWeave, buildLinkIndex: dist_1.buildLinkIndex, registry, fs, workspaceRoot: root }, weaveFilter ? { weaveFilter } : undefined);
        if (isUnfiltered)
            (0, stateCache_1.setCachedState)(state);
    }
    // Serialize per requested shape. The summary projection is the cheap
    // session-start map (skeleton + status, no step bodies / doc content) and is
    // emitted compact — indentation was ~28% of the full payload and nothing reads
    // it raw. The full shape keeps its pretty-printed, content-stripped form.
    let text;
    if (isSummary) {
        text = JSON.stringify((0, dist_3.toStateSummary)(state));
    }
    else {
        const replacer = includeContent
            ? undefined
            : (key, value) => (key === 'content' ? undefined : value);
        text = JSON.stringify(state, replacer, 2);
    }
    process.stderr.write(`[state] read uri=${uri} shape=${shapeParam ?? 'full'} cacheHit=${cacheHit} totalMs=${Date.now() - startedAt}\n`);
    return {
        contents: [{ uri, mimeType: 'application/json', text }],
    };
}
